import { connect } from "react-redux";
import DeviceManagementPage from "./DeviceManagementPage"
import { fetchAllDevices } from "../../../../redux/actions/device_actions"

const mapStateToProps = (state) => {
    return ({
        devices: state.devices,
    });
}

const mapDispatchToProps = (dispatch) => {
    return ({
        fetchAllDevices: (cancelToken) => dispatch(fetchAllDevices(cancelToken)),
    });
}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceManagementPage);
